import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService, Utilisateur, UtilisateurListe } from '@estel-numerique/galaclick-api';
import { map, Observable } from 'rxjs';

/** Incarnation d'un utilisateur par un compte dont le jeton de connexion Keycloak porte le rôle realm "superviseur" (vérifié côté WS). */
@Injectable({ providedIn: 'root' })
export class IncarnationService {
    private readonly wsAuth = inject(AuthService);

    /** Utilisateurs que le compte connecté peut incarner (filtrés côté WS) */
    public lister(): Observable<UtilisateurListe[]> {
        return this.wsAuth.getAuthIncarnables();
    }

    /** Incarne l'utilisateur ciblé : renvoie l'utilisateur et le jeton Galaclick, comme une connexion normale */
    public incarner(idutilisateur: number): Observable<HttpResponse<Utilisateur>> {
        // Le contrat type le corps de la réponse en string alors que le WS renvoie l'utilisateur
        return this.wsAuth.getAuthIncarnation(idutilisateur, 'response').pipe(map(resp => resp as unknown as HttpResponse<Utilisateur>));
    }
}
